import React from 'react';
import { Link } from '../../components/ui';
import {
  Icon,
  TooltipRoot,
  TooltipTrigger,
  TooltipContent,
} from '@socialchorus/shared-ui-components';
import { trackCreateUserGeneratedContentClick } from '../../models/user-generated-contents/analytics';
import { useTranslation } from 'react-i18next';
import './post-creation.scss';

const CreatePostLink = () => {
  const { t } = useTranslation();
  const handleClick = React.useCallback(() => {
    trackCreateUserGeneratedContentClick();
  }, []);

  return (
    <TooltipRoot>
      <TooltipTrigger asChild>
        <Link
          className="create-post-link"
          href="/post/new"
          action="push"
          onClick={handleClick}
          aria-label={t('nav_links.create_post')}
        >
          <Icon>edit</Icon>
        </Link>
      </TooltipTrigger>
      {/* py-2 = 8px vertical padding to match Figma; Solar's single-line tooltip defaults to py-1 (4px) */}
      <TooltipContent
        className="py-2"
        description={t('user_generated_content.create_post_cta_tooltip')}
        sideOffset={5}
      />
    </TooltipRoot>
  );
};

export default CreatePostLink;
